interface Account {
  pCode: string
  id: number
  name: string
  timeZone: string
  currencyCode: string
  countryCode: string
  permission: string
  lastAccessed?: string
  organization?: Organization
  hideMediaCost: boolean
  legalReviewStatus?: string
}

interface User {
  name: string
  email: string
}

interface Organization {
  id: number
  name: string
  accounts: string[]
  actions: string[]
}

interface Notification {
  id: number
  status: NotificationStatus
  viewed: NotificationViewed
  title: string
  message: string
  callToActionText?: string
  callToActionCallback?: string
  createdDate: Date
}

enum NotificationStatus {
  ACTIVE= 'ACTIVE',
  ARCHIVED= 'ARCHIVED',
  EXPIRED= 'EXPIRED'
}

enum NotificationViewed {
  UNREAD= 'UNREAD',
  READ= 'READ'
}

export {
  Account,
  User,
  Organization,
  Notification,
  NotificationStatus,
  NotificationViewed
}
